<div class="page-hero-background">
  <img class="page-background-image" src="/assets/icons/menu-hero-background-image.png" alt="" (load)="onBackgroundImageLoaded()" [class.loaded]="backgroundImageLoaded$$()" />
  <div class="page-background-overlay" [style.opacity]="backgroundOverlayOpacity$$()"></div>
</div>

<ion-header #headerElement class="header-with-overlay">
  <div class="header-background-overlay" [style.opacity]="backgroundOverlayOpacity$$()"></div>
  <div class="header-gradient-blur" [style.opacity]="gradientOpacity$$()"></div>
  <ion-toolbar [style.opacity]="toolbarOpacity$$()">
    <ion-buttons slot="start">
      <app-menu-button [color]="titleColor$$()" [filter]="iconDropShadow$$()"></app-menu-button>
    </ion-buttons>
    <ion-title [style.color]="titleColor$$()" [style.text-shadow]="titleTextShadow$$()">{{ 'menu.title' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" [scrollEvents]="true" (ionScroll)="handleScroll($event)">
  <div class="center-content">
    <section class="root">
      <app-account-card></app-account-card>
      <app-menu-subscription-card></app-menu-subscription-card>

      <ion-list-header>
        <ion-label>{{ 'menu.contacts.title' | transloco }}</ion-label>
      </ion-list-header>
      <app-contacts-card></app-contacts-card>

      <!-- Appearance -->
      <ion-list-header>
        <ion-label>{{ 'menu.appSettings.title' | transloco }}</ion-label>
      </ion-list-header>
      <ion-list [inset]="true">
        <ion-item [button]="true" [detail]="false">
          <ion-label>{{ 'menu.appSettings.menuItems.theme' | transloco }}</ion-label>
          <ion-toggle data-testid="dark-mode-toggle" [checked]="isUseDarkMode$$()" (ionChange)="handleToggleDarkMode($event)" slot="end"></ion-toggle>
        </ion-item>
        <ion-item [button]="true" [detail]="false">
          <lib-language-selector data-testid="language-selector" class="language-selector" [activeLanguage]="activeAppLanguage$$()" [availableLanguages]="availableAppLanguages$$()" (selectActiveLanguage)="handleChangeLanguage($event)" />
        </ion-item>
        <ion-item data-testid="accessibility-settings-item" [detail]="true" [button]="true" (click)="handleNotYetImplemented()">
          <ion-label>{{ 'menu.appSettings.menuItems.accessibilitySettings' | transloco }}</ion-label>
        </ion-item>
        <ion-item data-testid="notifications-item" [detail]="true" [button]="true" (click)="handleOpenNotificationSettings()">
          <ion-label>{{ 'menu.appSettings.menuItems.notifications' | transloco }}</ion-label>
        </ion-item>
      </ion-list>

      <!-- Help -->
      <ion-list-header>
        <ion-label>{{ 'menu.help.title' | transloco }}</ion-label>
      </ion-list-header>
      <ion-list [inset]="true">
        <ion-item data-testid="tutorial-item" [detail]="true" [button]="true" (click)="handleNotYetImplemented()">
          <ion-label>{{ 'menu.help.menuItems.tutorial' | transloco }}</ion-label>
        </ion-item>
        <ion-item data-testid="faq-item" [detail]="true" [button]="true" (click)="handleOpenFaq()">
          <ion-label>{{ 'menu.help.menuItems.faq' | transloco }}</ion-label>
        </ion-item>
        <ion-item data-testid="contact-support-item" [detail]="true" [button]="true" (click)="handleOpenContactSupport()">
          <ion-label>{{ 'menu.help.menuItems.contactSupport' | transloco }}</ion-label>
        </ion-item>
      </ion-list>

      <ion-list [inset]="true" class="list-without-header">
        <ion-item data-testid="feedback-item" [detail]="true" [button]="true" (click)="handleNotYetImplemented()">
          <ion-label>{{ 'menu.feedback' | transloco }}</ion-label>
        </ion-item>
      </ion-list>

      <app-shop-card></app-shop-card>

      <!-- Storage Management -->
      <ion-list-header>
        <ion-label>{{ 'menu.deviceSettings.title' | transloco }}</ion-label>
      </ion-list-header>
      <ion-list [inset]="true">
        <ion-item data-testid="system-settings-item" [detail]="false" [button]="true" (click)="handleOpenAppSettings()" *libIfNative>
          <ion-label>{{ 'menu.deviceSettings.menuItems.systemSettings' | transloco }}</ion-label>
          <ion-icon slot="end" name="open-externally"></ion-icon>
        </ion-item>
        <ion-item data-testid="storage-management-item" [detail]="true" [button]="true" (click)="handleOpenStorageManagement()" class="storage-management-item">
          @if (isStorageInformationShown$$()) {
            <div class="multi-line">
              <ion-label>{{ 'menu.deviceSettings.menuItems.storageManagement' | transloco }}</ion-label>
              @if (isCalculatingFreeDeviceSpace$$()) {
                <ion-note color="medium">{{ 'menu.deviceSettings.calculatingFreeSpace' | transloco }}</ion-note>
              } @else {
                <ion-note color="medium">
                  {{ 'menu.deviceSettings.freeSpace' | transloco: { freeSpace: freeDeviceSpace$$() | formatStorageSize } }}
                </ion-note>
              }
            </div>
          } @else {
            <ion-label>{{ 'menu.deviceSettings.menuItems.storageManagement' | transloco }}</ion-label>
          }
        </ion-item>
      </ion-list>

      <!-- Information -->
      <ion-list-header>
        <ion-label>{{ 'menu.informationAndLegal.title' | transloco }}</ion-label>
      </ion-list-header>
      <ion-list [inset]="true">
        <ion-item data-testid="terms-conditions-item" [button]="true" [detail]="true" (click)="handleOpenTermsAndConditions()">
          <ion-label>{{ 'menu.informationAndLegal.menuItems.termsAndConditions' | transloco }}</ion-label>
        </ion-item>
        <ion-item data-testid="consent-item" [button]="true" [detail]="true" (click)="handleOpenConsentModal()">
          <ion-label>{{ 'menu.informationAndLegal.menuItems.consent' | transloco }}</ion-label>
        </ion-item>
      </ion-list>

      @if (isTestSectionEnabled) {
        <!-- Tests -->
        <ion-list-header>
          <ion-label>Tests</ion-label>
        </ion-list-header>
        <ion-list [inset]="true">
          <ion-item data-testid="shot-analysis-tests-item" (click)="handleShowAnalysisTests()" [detail]="true">
            <ion-label>{{ 'menu.tests.shotAnalysis.title' | transloco }}</ion-label>
          </ion-item>
          <ion-item data-testid="token-tests-item" [button]="true" [detail]="true" (click)="handleTokenTests()">
            <ion-label>Token Authentication Tests</ion-label>
          </ion-item>
          @if (isMockHuntingDeviceEnabled) {
            <ion-item data-testid="mock-hunting-device-item">
              <ion-label>{{ 'menu.tests.mockHuntingDevice.title' | transloco }}</ion-label>
              <ion-toggle data-testid="mock-hunting-device-toggle" [checked]="isMockDeviceConnected$$()" (ionChange)="handleToggleMockHuntingDevice($event)" slot="end"></ion-toggle>
            </ion-item>
          }
          <ion-item data-testid="webrtc-tests-item" [button]="true" [detail]="true" (click)="handleWebRTCTest()">
            <ion-label>{{ 'menu.tests.webrtc.title' | transloco }}</ion-label>
          </ion-item>
          <ion-item data-testid="stream-stats-item">
            <ion-label>Live Stream Diagnostics</ion-label>
            <ion-toggle data-testid="stream-stats-toggle" [checked]="isStreamStatsEnabled$$()" (ionChange)="handleToggleStreamStats($event)" slot="end"></ion-toggle>
          </ion-item>
        </ion-list>
      }

      <!-- Reset App -->
      <ion-list [inset]="true" class="list-without-header reset-app-item">
        <ion-item [button]="true" [detail]="false">
          <app-reset-application />
        </ion-item>
      </ion-list>

      <!-- Account -->
      <ion-list [inset]="true" class="list-without-header">
        <ion-item [button]="true" [detail]="false" (click)="handleLogout()">
          <lib-app-button data-testid="logout-button" fill="clear" class="logout-button" size="default" [loading]="loggingOut$$()">{{ 'menu.logout' | transloco }}</lib-app-button>
        </ion-item>
      </ion-list>

      @if (version && version !== 'BUILD_VERSION_PLACEHOLDER') {
        <section class="app-version">
          <ion-text class="app-version-label"> {{ version }}</ion-text>
          <ion-text class="user-email"> {{ userEMail$$() }} </ion-text>
        </section>
      }
    </section>
    <ion-loading [isOpen]="isConsentLoading$$()"></ion-loading>
  </div>
</ion-content>

<!-- Offline banner -->
<app-offline-banner></app-offline-banner>
